import React from "react";

import {
  CalendarIcon,
  DegreeIcon,
  DotSeparatorIcon,
  PackageIcon,
  TransitionArrowIcon,
} from "../../icons";
import {
  getGraduationYear,
  getPlacedMonthMeta,
  getShortenedDegree,
} from "../../utils/reviewUtils";
import { REACH_CARD_DIVIDER } from "../../utils/reachMedia";
import ReachRim from "../ReachRim/ReachRim";

import "./PlacedStudentCardDark.css";

export default function PlacedStudentCardDark({ review }) {
  const { year } = getPlacedMonthMeta(review);
  const studentName = review["Stundent Name"];
  const profileUrl = review["Student profile image Url"];
  const packageLpa = review["Package in lpa"];
  const graduationYear = getGraduationYear(review);
  const shortenedDegree = getShortenedDegree(review);
  const companyLogoUrl = review["Company logo Url"];
  const testimonial = (review["One liner Testimonial"] || "").trim();
  const yearSuffix = year ? String(year).slice(-2) : "";
  const placedMonthLabel = yearSuffix
    ? `${review["Placed Month"]}' ${yearSuffix}`
    : review["Placed Month"];
  const packageLabel = packageLpa ? `${packageLpa}LPA` : "";

  return (
    <ReachRim
      variant="placement"
      outerClassName="keen-slider__slide"
      className="placed-student-card"
    >
      <div className="card-frst-cont">
        <div className="image-8128822519 w-embed">
          <img
            src={profileUrl}
            alt={`${studentName} profile`}
            loading="lazy"
            width="100%"
          />
        </div>
        <div className="div-block-1831980521448570">
          <h3 className="heading-3671140">{studentName}</h3>
          <div className="div-block-1831980521448569">
            <div className="month-cont">
              <CalendarIcon />
              <div className="month-text">{placedMonthLabel}</div>
            </div>
            <DotSeparatorIcon />
            <div className="month-cont">
              <PackageIcon />
              <div className="month-text">{packageLabel}</div>
            </div>
            <DotSeparatorIcon />
            <div className="month-cont">
              <DegreeIcon />
              <div className="month-text">{graduationYear}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-sec-cont placed-card-transition">
        <div className="div-block-1831980521448571 placed-card-transition__before">
          <div className="text-block-941288240428">Before</div>
          <div className="text-block-941288240429">{shortenedDegree}</div>
        </div>
        <div className="placed-card-transition__arrow" aria-hidden="true">
          <TransitionArrowIcon />
        </div>
        <div className="div-block-1831980521448572 placed-card-transition__after">
          <div className="text-block-941288240428">After</div>
          <div className="image-8128822520 w-embed">
            <img src={companyLogoUrl} alt={`${review["Company Name"]} logo`} loading="lazy" height="100%" />
          </div>
        </div>
      </div>
      {testimonial ? (
        <>
          <div className="placed-card-divider" aria-hidden="true">
            <img src={REACH_CARD_DIVIDER} alt="" />
          </div>
          <p className="placed-card-description">{testimonial}</p>
        </>
      ) : null}
    </ReachRim>
  );
}
